<template>
	<div class="w-full flex flex-wrap slider-component lg:pl-10 xl:px-0 xl:transform xl:translate-x-14">
		<div class="w-full lg:w-1/4 lg:pl-5 xl:pl-0">
			<div v-if="activeIndex >= 0 && activeSlide" class="lg:text-center hidden h-full lg:border-b lg:border-black lg:border-t lg:flex lg:items-center lg:justify-center ">
				<div class="px-6 lg:px-0">
					<h4 class="text-hamlet-gold mb-4 lg:mb-10 border-t border-black lg:border-0 pt-10" v-html="activeSlide.heading"></h4>
					<div class="lg:px-6 mb-10 lg:mb-0">
						<h5 v-html="activeSlide.content">Text</h5>
					</div>

					<div class="mt-16 lg:flex flex-wrap justify-center">
						<div class="mx-3 cursor-pointer" @click="slidePrev('desktop')">
							<svg width="15" height="15" viewBox="0 0 15 15" fill="none" class="-rotate-180 transform" xmlns="http://www.w3.org/2000/svg">
								<path d="M3.36277 7.49007L1.33006e-06 -6.55671e-07L15 7.49007L6.74394e-07 15L3.36277 7.49007Z" fill="black"/>
							</svg>
						</div>
						<div class="mx-3 cursor-pointer" @click="slideNext('desktop')">
							<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M3.36277 7.49007L1.33006e-06 -6.55671e-07L15 7.49007L6.74394e-07 15L3.36277 7.49007Z" fill="black"/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="px-6 pt-14 lg:hidden" v-if="activeIndexMobile >= 0 && activeMobileSlide">
				<div class="border-t border-black pt-12">
					<h3 class="text-hamlet-gold mb-4 lg:mb-10" v-html="activeMobileSlide.heading"></h3>
					<div class="lg:px-6 mb-10 lg:mb-0">
						<h5 v-html="activeMobileSlide.content" />
					</div>
				</div>
			</div>
		</div>
		<div class="w-full px-6  lg:hidden">
			<swiper
					:options="swiperOptionMobile"
					ref="swiperMobile"
					@slideChange="changeIndex('mobile')"
			>
				<swiper-slide v-for="(slide, index) in slides"  v-bind:key="'mslide'+index">
					<div class="flex flex-wrap">
						<img class="w-full" :src="slide.mobileImage" />
					</div>
				</swiper-slide>
			</swiper>
		</div>
		<div class="hidden lg:block lg:w-3/4 flex justify-end">
			<div class="translate pl-5 xl:pl-0 xl:translate-x-20">
				<swiper
						class="desktop-slider"
						ref="mySwiper"
						:options="swiperOptions"
						@slideChange="changeIndex('desktop')"
				>
					<swiper-slide v-for="(slide, index) in slides"  v-bind:key="'slide'+index">
						<div
								class="flex flex-wrap relative"
						>
							<img class="flex relative" :src="slide.image" />
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<div class="w-full hidden lg:flex justify-end h-14">
			<div class="w-full text-center lg:text-left lg:w-3/4 translate lg:translate-x-5 xl:translate-x-20 mt-2 lg:mt-4">
				<span class="small text-white opacity-50 uppercase hidden lg:block" v-if="activeSlide" v-html="activeSlide.caption" />
			</div>
		</div>
		<div class="flex w-full lg:hidden px-6">
			<span class="small text-white opacity-50 uppercase mt-5" v-if="activeMobileSlide" v-html="activeMobileSlide.caption" />
			<div class="mt-5 ml-auto flex">
				<div class="mx-3 cursor-pointer" @click="slidePrev('mobile')">
					<svg width="15" height="15" viewBox="0 0 15 15" fill="none" class="-rotate-180 transform" xmlns="http://www.w3.org/2000/svg">
						<path d="M3.36277 7.49007L1.33006e-06 -6.55671e-07L15 7.49007L6.74394e-07 15L3.36277 7.49007Z" fill="black"/>
					</svg>
				</div>
				<div class="mx-3 cursor-pointer" @click="slideNext('mobile')">
					<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M3.36277 7.49007L1.33006e-06 -6.55671e-07L15 7.49007L6.74394e-07 15L3.36277 7.49007Z" fill="black"/>
					</svg>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default {
	props: {
		slides: {
			type: Array,
			default: () => []
		},
	},
	components: {
		Swiper,
		SwiperSlide
	},
	data() {
		return {
			swiperOptions: {
				loop: true,
				slidesPerView: 2,
				centeredSlides: false,
				centeredSlidesBounds: true,
				spaceBetween: 20,
				initialSlide: 0,
				allowTouchMove: false
			},
			swiperOptionMobile: {
				loop: true,
				initialSlide: 0,
				slidesPerView: 1,
				spaceBetween: 0,
				centeredSlides: true,
				allowTouchMove: false
			},
			activeIndex: 0,
			activeIndexMobile: 0,
		}
	},
	computed: {
		swiper() {
			if(!this.$refs.mySwiper) return null;
			return this.$refs.mySwiper.$swiper;
		},
		swiperMobile() {
			if(!this.$refs.swiperMobile) return null;
			return this.$refs.swiperMobile.$swiper;
		},
		activeSlide() {
			if(this.activeIndex===null){ return false; }
			return this.slides[this.activeIndex];
		},
		activeMobileSlide() {
			if(this.activeIndexMobile===null){ return false; }
			return this.slides[this.activeIndexMobile];
		},
	},
	methods: {
		getCaption(type){
			if(!this.$refs.mySwiper || !this.$refs.swiperMobile){ return false; }
			if(type === 'desktop'){
				return this.slides[this.swiper.realIndex].caption;
			}
			return this.slides[this.swiperMobile.realIndex].caption;
		},
		getItem(type, name){
			if(!this.$refs.mySwiper || !this.$refs.swiperMobile){ return false; }
			const index = type === 'desktop'? this.swiper.realIndex: this.swiperMobile.realIndex;
			return this.slides[index][name];
		},
		slideNext(type){
			type === 'desktop'? this.swiper.slideNext():this.swiperMobile.slideNext()
		},
		slidePrev(type){
			type === 'desktop'? this.swiper.slidePrev():this.swiperMobile.slidePrev()
		},
		changeIndex(type){
			if(type === 'desktop') {
				this.activeIndex = this.swiper.realIndex
			}else{
				this.activeIndexMobile = this.swiperMobile.realIndex
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.activeIndex = this.swiper.activeIndex;
		})
	}
}
</script>

<style>

</style>
